import type { TabularTreeRowProps } from '@ztechapps/webui.data-tools'
import type { ProductBillOfMaterial } from '@ztechapps/common.contract'
import { NewBom } from './NewBom'
import React from 'react'

export const NewRow = ({ item, items, leftMarginStyle }: TabularTreeRowProps<ProductBillOfMaterial>) => {
  const parentProductId = item?.product._id
  return (
    <tr>
      <td colSpan={10} className="p-0 m-0">
        <div style={leftMarginStyle}>
          <NewBom productId={parentProductId} billOfMaterials={items} />
        </div>
      </td>
    </tr>
  )
}
